import { applyPageMetadata } from './pageEffects';
export const siteUrl = process.env.REACT_APP_SITE_URL;
export function setContentSeo({title, description, path, privatePage = false, schema}) {
  applyPageMetadata({title, description});
  const canonical = new URL(path === '/home' ? '/' : path, siteUrl).href;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
  link.href = canonical;
  let robots = document.querySelector('meta[name="robots"]');
  if (!robots) { robots = document.createElement('meta'); robots.name = 'robots'; document.head.appendChild(robots); }
  robots.content = privatePage || window.location.hostname !== new URL(siteUrl).hostname ? 'noindex, nofollow' : 'index, follow';
  document.querySelector('[data-jos-schema]')?.remove();
  if (schema) {
    const script = document.createElement('script'); script.type = 'application/ld+json'; script.setAttribute('data-jos-schema', 'true');
    script.textContent = JSON.stringify(schema); document.head.appendChild(script);
  }
}

export const firmSchema = () => ({'@context': 'https://schema.org', '@type': 'LegalService',
  name: 'JOS Criminal Law', url: siteUrl, telephone: '+1-949-883-6001',
  address: {'@type': 'PostalAddress', streetAddress: '1918 West Chapman Ave, Suite 201', addressLocality: 'Orange', addressRegion: 'CA', postalCode: '92868', addressCountry: 'US'},
  areaServed: {'@type': 'AdministrativeArea', name: 'Orange County, California'}});